{
    "NAME": "Gerätelistensprache",
    "DeviceList_Column_DeviceNumber": "Gerät",
    "DeviceList_Column_DeviceNumberInternal": "Verlängerung",
    "DeviceList_Column_Description": "Beschreibung",
    "DeviceList_Column_Partition": "Partition",
    "DeviceList_Column_DeviceType": "Gerätetyp",
    "DeviceList_Column_IDOnTelSys": "Ressourcenkonto",
    "DeviceList_Column_QueueStatus": "Warteschlangenstatus",
    "DeviceList_Column_Users": "Benutzer",
    "DeviceList_Filter_DeviceType": "Gerätetyp",
    "DeviceList_Filter_Partition": "Partition",
    "DeviceList_Add_Disabled_SelectTelephonyServer": "Wählen Sie einen Telefonieserver aus, um ein Gerät hinzuzufügen.",
    "DeviceList_Users_MoreUsers": "[{} weitere Benutzer]",
    "DeviceList_Value_None": "Keiner",
    "DeviceList_Value_All": "Alle"
}